import React, { useState } from 'react';
import ReactQuill from 'react-quill';

import { DescriptionContainer, DescriptionScrollContainer, TestTitle, DescriptionText, QuillContainer } from './styles';
import { useAppContext } from 'hooks/useContext';

const Editor = {
  modules: {
    toolbar: [
      [{ header: '1' }, { header: '2' }],
      ['bold', 'italic', 'underline'],
      [{ align: [] }],
      [{ list: 'ordered' }, { list: 'bullet' }],
      ['code-block', 'link', 'clean'],
    ],
    clipboard: {
      // toggle to add extra line breaks when pasting HTML:
      matchVisual: false,
    },
  },
  formats: ['header', 'bold', 'italic', 'underline', 'list', 'bullet', 'link', 'align', 'code-block'],
};

export default function FreecodeText({ title, textContent, isCreator = false }) {
  const { isDarkMode } = useAppContext();

  const updateText = (updatedValue) => {
    // TODO do something to update texts if in creator
    console.log('updated value:', updatedValue);
  };

  const [editorMode, setEditorMode] = useState(false);

  return (
    <DescriptionContainer isDarkMode={isDarkMode}>
      <DescriptionScrollContainer>
        {title && <TestTitle isDarkMode={isDarkMode}>{title}</TestTitle>}
        {editorMode ? (
          <QuillContainer isDarkMode={isDarkMode}>
            <ReactQuill
              value={textContent}
              onChange={updateText}
              modules={Editor.modules}
              formats={Editor.formats}
              theme="snow"
              preserveWhitespace={true}
            />
          </QuillContainer>
        ) : (
          <DescriptionText
            isDarkMode={isDarkMode}
            dangerouslySetInnerHTML={{ __html: textContent }}
            onClick={() => setEditorMode(isCreator && true)}
          />
        )}
      </DescriptionScrollContainer>
    </DescriptionContainer>
  );
}
